import { render, staticRenderFns } from "./PurchaseTwo.vue?vue&type=template&id=1c573e70&scoped=true&"
import script from "./PurchaseTwo.vue?vue&type=script&lang=js&"
export * from "./PurchaseTwo.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseTwo.vue?vue&type=style&index=0&id=1c573e70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c573e70",
  null
  
)

export default component.exports